import {motion} from 'framer-motion';


export const HistoryItem = ({data}) => {

    const animation = {
        hidden: { opacity: 0, y: -100 },
        show: {
          opacity: 1,
          y: 0,
          transition: {
            staggerChildren: 0.7,
            duration: 0.5,
            type: 'spring',
            damping: 10,
            stiffness: 100 
          }
        }
      };

    const result = data.map((item) =>  (
        <div className="row mt-2">
            <div class="accordion accordion-flush" id="accordionFlushExample">
                <motion.div class="accordion-item"
                    variants={animation}
                    initial="hidden"
                    animate="show"
                >
                    <h2 class="accordion-header">
                    <button class="accordion-button collapsed custom" type="button" data-bs-toggle="collapse" data-bs-target={`#order-${item.id}`}>
                        <span>Замовлення: №{item.id}</span><span className="ms-auto text-end">Статус: ...</span>
                    </button>
                    </h2>
                    <div id={`order-${item.id}`} class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Товар</th>
                                        <th scope="col">Кількість</th>
                                        <th scope="col">Ціна</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.orders.map(item => (
                                        <tr>
                                            <td>{item.name}</td>
                                            <td>{item.qtt}</td>
                                            <td>{item.amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={2}>Загальна сума</td>
                                        <td>{item.amount}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    ))

    return result
}